// src/pages/gmail-callback.tsx
'use client';

import { useEffect } from 'react';

const GmailCallback = () => {
  useEffect(() => {
    const currentUrl = window.location.href;
    console.log('[CALLBACK DEBUG] Current URL:', currentUrl);

    const url = new URL(currentUrl);
    const code = url.searchParams.get('code');
    const error = url.searchParams.get('error');

    console.log('[CALLBACK DEBUG] Code:', code);
    console.log('[CALLBACK DEBUG] Error:', error);

    if (error) {
      console.error('[CALLBACK DEBUG] OAuth error received:', error);
      window.opener?.postMessage({ type: 'GMAIL_AUTH_ERROR', error }, '*');
      window.close();
      return;
    }

    if (code) {
      console.log('[CALLBACK DEBUG] OAuth code found. Sending to backend...');
      fetch(`https://gmail-oauth-backend-p21j.onrender.com/gmail-oauth?action=callback&code=${code}`)
        .then((res) => res.json())
        .then((data) => {
          console.log('[CALLBACK DEBUG] Backend responded with success:', data);
          window.opener?.postMessage({ type: 'GMAIL_AUTH_SUCCESS', data }, '*');
          window.close();
        })
        .catch((err) => {
          console.error('[CALLBACK DEBUG] Error contacting backend:', err);
          window.opener?.postMessage({ type: 'GMAIL_AUTH_ERROR', error: err.message }, '*');
          window.close();
        });
    } else {
      console.warn('[CALLBACK DEBUG] No code found in URL');
      window.opener?.postMessage({ type: 'GMAIL_AUTH_ERROR', error: 'No code found' }, '*');
      window.close();
    }
  }, []);

  return <p>Finishing Gmail authentication...</p>;
};

export default GmailCallback;
